// extracted by mini-css-extract-plugin
module.exports = {"hiddenInput":"hidden-module--hiddenInput--2SCDC"};